import React, {FC, useCallback, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import Confetti from 'react-confetti';
// custom
import logo from '../../../assets/img/customer-service.png'; 
import NavbarUser from '../../../components/navbar/Navbar.user';
import { useSelector } from 'react-redux';
import { IUserState } from '../../../common/state/profile/user';
import { retrieveLocalStorageItem } from '../../../common/helpers/LocalStorage';
import { postOfflineRegistrationEmail, retrieveSubscriptionDetails } from '../../../common/async/AsyncCalls';
import { ISubscriptionResponse } from '../../../common/state/subscriptions/subscription';
import { toast } from 'react-toastify';

const OfflineRegistrationSuccess: FC = () => {
    // confetti settings
    const [width, setWidth] = useState<number>(document.body.clientWidth);
    const [height, setHeight] = useState<number>(document.body.clientHeight);
    const [confettiRun, toggleConfettiRun] = useState<boolean>(true);

    // states
    const token = useSelector(({user} : {user: IUserState}) => user.token);
    let subscriptionId = retrieveLocalStorageItem('subscription');
    subscriptionId = remove_special_chars(subscriptionId);

    // lifecycle
    const triggerSalesCompleteEmails = useCallback(async()=>{
        if (!token || token === '' || !subscriptionId || subscriptionId === '') return ;
        try {
            
            const subscriptionResponse = await retrieveSubscriptionDetails(token, subscriptionId);
            const subscriptionDetails: ISubscriptionResponse = subscriptionResponse?.data as ISubscriptionResponse;
            await postOfflineRegistrationEmail(token, {
                    name: `${subscriptionDetails.personal_info.first_name} ${subscriptionDetails.personal_info.last_name}`,
                    event: subscriptionDetails.general_info.event_title,
                    email: subscriptionDetails.personal_info.email,
                    contact_number: subscriptionDetails.personal_info.contact,
                    reg_type: subscriptionDetails.general_info.reg_type,                    
                });            
            toast(`Email sent!`);
        } catch (err) {
             console.log('Error - sending offline email: ', err);
        } 
    },[token, subscriptionId]);

    useEffect(()=>{
        // #1. Confetti settings
        setWidth(document.body.clientWidth);
        setHeight(document.body.clientHeight);
        setTimeout(() => toggleConfettiRun(false), 5000);

        // #2. Send emails
        triggerSalesCompleteEmails();

        // #3. Remove the parameters from the URL
        setTimeout(()=>{
            let url = window.location.href;
            let newUrl = url.replace(/\?.*/, '');                        
            window.history.replaceState({}, '', newUrl)},3000);
    },[]);
    return <React.Fragment>
        <Confetti
                width={width}
                height={height}
                numberOfPieces={100}
                recycle={confettiRun}/>
        <NavbarUser />
        <div
            className="flex flex-col items-center justify-center h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
            <div className="flex flex-col items-center justify-center max-w-md overflow-hidden bg-gray-100 rounded shadow-lg fadeIn slideInUp">
                <img className="w-1/2 mt-6" src={logo} alt="Sunset in the mountains" />
                <div className="flex flex-col items-center justify-center px-6 py-4">
                    <div className="mb-2 text-xl font-bold text-blue-800">Thank you for registering</div>
                    <p className="mb-4 text-gray-700 dartext-base">
                        There is some paperwork to be done, we will call you!
                    </p>
                    <p className="mb-4 text-sm text-gray-700 dartext-base">
                        We will reach out to you on the Contact number and email you provided. For any clarification, please feel free to reach out to our team
                    </p>
                </div>
                <div className="px-6 pt-4 pb-2">
                    <Link to="/profile" className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-100 rounded-full bg-secondary-500">Home</Link>                                        
                </div>
            </div>
        </div>
    </React.Fragment>
};

export default OfflineRegistrationSuccess;

export function remove_special_chars(input: string): string {
    input = input.replace(/['"]/g, '');
    return input.trim();
}